export enum ConnectionPointStatus {
    OK = 0,
    NotTested = 100,
    Desynchronized = 200,
    SmtpProblem = 250,
    NotConfigured = 300,
    NotAvailable = 400,
    RequiresUpdate = 500,
    Deprecated = 550,
    Unknown = 600
}